/**
 * 精选车辆推荐列表
 */
import React, { Component } from 'react';
import { Modal, Form, Input, InputNumber, DatePicker, Switch, Select, Radio, Row } from 'antd';
import moment from 'moment';

import http from '../../../axios/http';
import messager from '../../ui/messager';

//商户选择
import MemberSelect from '../../crm/member/MemberSelect';

const fields = [{
    "text": "推荐车辆",
    "field": "vehicleId",
    "vehicle": true,
    "disabled":true,
    rules: [
        { required: true, message: '车辆不能为空!' },
    ]
}, {
    "text": "推荐开始时间",
    "field": "startTime",
    "date": true,
    rules: [
        { required: true, message: '推荐开始时间不能为空!' },
    ]
}, {
    "text": "",
    "field": "anc",
    "group": true,
}, {
    "text": "推荐结束时间",
    "field": "endTime",
    "date": true,
    rules: [
        { required: true, message: '推荐结束时间不能为空!' },
    ]
}, {
    "text": "是否置顶",
    "field": "roof",
    "radio": true
} ];


class VehicleRecommendEditForm extends Component {

    state = {
        vehicleList: [],  //车辆信息列表，用于选择车辆
        vehicleName: "",    //选中的车辆名称
        initFlag: true,
    }

    componentWillReceiveProps(that) {
        if (that.visible) {
            let memberCode = that.editData.memberCode;
            if (this.state.initFlag && memberCode != null && memberCode !== "") {
                this.setState({ initFlag: false });
                this.memberSelect({ code: memberCode, initFlag: true });
            }
        }
    }

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            let vehicleName = this.props.editData.vehicleName;
            if (values["startTime"] != null) {
                values["startTime"] = values["startTime"].format("YYYY-MM-DD HH:mm:ss");
            }
            if (values["endTime"] != null) {
                values["endTime"] = values["endTime"].format("YYYY-MM-DD HH:mm:ss");
            }
            values["roof"] = values["roof"] ? 1 : 0;
            values["vehicleName"] = vehicleName;
            http.post({
                url: '/vehicleRecommend/saveRecomend',
                data: values,
                success: (res) => {
                    let queryData = this.props.queryData;
                    queryData.notChangePage = true;
                    this.props.successCallback(queryData);
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };

    //选择会员后，进行查询车辆信息
    memberSelect = (member) => {
        if (!member.initFlag) {
            const { form } = this.props;
            form.setFieldsValue({ "vehicleId": null, vehicleName: null });
        }
        http.get({
            url: '/vehicleRecommend/findVehicleByMember',
            data: { "memberCode": member.code },
            success: (res) => {
                if (res == null) res = [];
                this.setState({ vehicleList: res });
            }
        });
    }

    onSelect = (vehicleId, option) => {
        let vehicleList = this.state.vehicleList;
        let vehicleName = null;
        for (let i = 0; i < vehicleList.length; i++) {
            // eslint-disable-next-line eqeqeq
            if (vehicleList[i]["id"] == vehicleId) {
                vehicleName = vehicleList[i]["name"];
                break;
            }
        }
        this.setState({ vehicleName: vehicleName });
    }

    radioGroupChange =(e) => {
        let value = e.target.value;
        const { form } = this.props;
        let time = form.getFieldValue("startTime");
        let a = new moment(time);
        a.add(value, 'hours');
        form.setFieldsValue({"endTime": a});
    }

    createDom = (data) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let itemDom = item.group ? (
                <Row key={i} style={{ marginBottom: "24px" }}>
                    <Radio.Group onChange={this.radioGroupChange}>
                        <Radio.Button value="1">1小时</Radio.Button>
                        <Radio.Button value="6">6小时</Radio.Button>
                        <Radio.Button value="12">半天</Radio.Button>
                        <Radio.Button value="24">一天</Radio.Button>
                        <Radio.Button value="48">两天</Radio.Button>
                        <Radio.Button value="72">三天</Radio.Button>
                        <Radio.Button value="168">一周</Radio.Button>
                    </Radio.Group>
                </Row>
            )
                : (
                    <Form.Item key={i} label={item.text + "："}>
                        {
                            getFieldDecorator(item.field, {
                                rules: item.rules,
                                initialValue: item.date ? (editData[item.field] == null || editData[item.field] === "" ? null : moment(editData[item.field]))
                                    : item.radio ? editData[item.field] === 1
                                        : item.vehicle ? editData[item.field] == null ? "" : editData[item.field] + ""
                                            : editData[item.field],
                                valuePropName: item.radio ? 'checked' : 'value'
                            })(
                                item.number ?
                                    <InputNumber precision={0} min={0} max={999} style={{ width: '100%' }} />
                                    : item.date ? <DatePicker showTime={true} style={{ width: '100%' }} />
                                        : item.radio ? <Switch checkedChildren="是" unCheckedChildren="否" />
                                            : item.member ? <MemberSelect mall={1} onSelect={this.memberSelect} />
                                                : item.vehicle ?
                                                    <Select allowClear={false} onSelect={this.onSelect} disabled={item.disabled}>
                                                        {this.state.vehicleList.map(d => <Select.Option key={d["id"]}> {d["name"]} </Select.Option>)}
                                                    </Select>
                                                    : <Input disabled={item.disabled} />
                            )
                        }
                    </Form.Item>
                );
            dom.push(itemDom);
        }
        return dom;
    };

    afterClose = () => {
        this.setState({ vehicleList: [], vehicleName: null, initFlag: true });
        this.props.form.resetFields();
    }

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                visible={visible}
                title="精选好车推荐维护"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={this.afterClose}
            >
                <Form layout="vertical" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                    {this.createDom(fields)}
                </Form>
            </Modal>
        );
    }
}

const VehicleRecommendEdit = Form.create()(VehicleRecommendEditForm);

export default VehicleRecommendEdit;